import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import { Meter } from 'portal/components/Utilities/Meters/Interface'

import {
  addMeterFailure,
  deleteMeterFailure,
  editMeterFailure,
  metersLoadSuccess,
  metersLoadFailure,
  METERS_LOAD,
  ADD_METER,
  DELETE_METER,
  EDIT_METER,
  MetersLoadAction,
  AddMeterAction,
  DeleteMeterAction,
  EditMeterAction
} from './actions'

function* metersLoadSaga(action: MetersLoadAction) {
  const { accountId, projectId } = action

  try {
    let meters: Meter[] = []
    const response: { data: Meter[] } = yield call(() =>
      axios.get(
        `/accounts/${accountId}/projects/${projectId}/utilities/meters`,
        {}
      )
    )

    meters = response && response.data ? [...response.data] : []

    yield put(metersLoadSuccess(accountId, projectId, meters))
  } catch (error) {
    console.error(error)
    yield put(metersLoadFailure(accountId, projectId, error))
  }
}

function* addMeterSaga(action: AddMeterAction) {
  const {
    accountId,
    projectId,
    meterName,
    meterReference,
    utilityType,
    reload,
    showSuccessNotification,
    showFailureNotification
  } = action
  try {
    yield call(() =>
      axios.post(
        `/accounts/${accountId}/projects/${projectId}/utilities/meters/register`,
        {
          meterName,
          meterReference,
          utilityType
        },
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              reload()
              showSuccessNotification()
              return true
            }
            showFailureNotification()
            return false
          }
        }
      )
    )
  } catch (error) {
    yield put(addMeterFailure(accountId, projectId, error))
  }
}

function* editMeterSaga(action: EditMeterAction) {
  const {
    accountId,
    projectId,
    meterId,
    meterName,
    meterReference,
    utilityType,
    reload,
    showSuccessNotification,
    showFailureNotification
  } = action
  try {
    yield call(() =>
      axios.put(
        `/accounts/${accountId}/projects/${projectId}/utilities/meters/${meterId}`,
        {
          meterName,
          meterReference,
          utilityType
        },
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              reload()
              showSuccessNotification()
              return true
            }
            showFailureNotification()
            return false
          }
        }
      )
    )
  } catch (error) {
    yield put(editMeterFailure(accountId, projectId, error))
  }
}

function* deleteMeterSaga(action: DeleteMeterAction) {
  const {
    accountId,
    projectId,
    meterId,
    reload,
    showSuccessNotification,
    showFailureNotification
  } = action
  try {
    yield call(() =>
      axios.delete(
        `/accounts/${accountId}/projects/${projectId}/utilities/meters/${meterId}`,
        {
          validateStatus: status => {
            if (status === 200 || status === 201 || status === 204) {
              reload()
              showSuccessNotification()
              return true
            }
            showFailureNotification()
            return false
          }
        }
      )
    )
  } catch (error) {
    yield put(deleteMeterFailure(accountId, projectId, meterId, error))
  }
}

export function* watch() {
  yield all([takeLatest(METERS_LOAD, metersLoadSaga)])
  yield takeEvery(ADD_METER, addMeterSaga)
  yield takeEvery(EDIT_METER, editMeterSaga)
  yield takeEvery(DELETE_METER, deleteMeterSaga)
}
